export default __webpack_public_path__ + "static/media/blackjack2.533e4ae6.jpg";